function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "ICON"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Data_ic 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M78 108H26a2 2 0 01-2-2V52H2a2 2 0 01-1.39-3.44l50-48a2 2 0 012.77 0l50 48A2 2 0 01102 52H80v54a2 2 0 01-2 2zm-50-4h48V50a2 2 0 012-2h19L52 4.77 7 48h19a2 2 0 012 2z",
  fill: "#666"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104 156a2 2 0 01-1.39-.56l-50-48A2 2 0 0154 104h22V50a2 2 0 012-2h52a2 2 0 012 2v54h22a2 2 0 011.39 3.44l-50 48a2 2 0 01-1.39.56zm-45-48l45 43.23L149 108h-19a2 2 0 01-2-2V52H80v54a2 2 0 01-2 2z",
  fill: "#e60000"
})));

var SvgDataMid = function SvgDataMid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 156 156",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgDataMid;